module.exports = __webpack_public_path__ + "img/sm-2022-04-19_12-21-42.20f7cfc8.jpg";